import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AccessibilityWidget from "@/components/AccessibilityWidget";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import EvaluationForm from "@/pages/EvaluationForm";
import Nutrition from "@/pages/Nutrition";
import Training from "@/pages/Training";
import Tracking from "@/pages/Tracking";
import Library from "@/pages/Library";
import Plans from "@/pages/Plans";
import Whatsapp from "@/pages/Whatsapp";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import SuccessStories from "@/pages/SuccessStories";
import ExerciseGuide from "@/pages/ExerciseGuide";
import SupplementsGuide from "@/pages/SupplementsGuide";
import FoodGuide from "@/pages/FoodGuide";
import MyLibrary from "@/pages/MyLibrary";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (NOT useEffect — too late)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacidad" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/terms-of-use" element={<Terms />} />
      <Route path="/terminos" element={<Terms />} />
      <Route path="/terminos-de-uso" element={<Terms />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/eliminar-cuenta" element={<DeleteAccount />} />
      <Route path="/login" element={<Login />} />
      <Route path="/planes" element={<Plans />} />
      <Route path="/evaluacion" element={<EvaluationForm />} />
      <Route path="/biblioteca" element={<Library />} />
      <Route path="/historias" element={<SuccessStories />} />
      <Route path="/ejercicios" element={<ExerciseGuide />} />
      <Route path="/suplementacion" element={<SupplementsGuide />} />
      <Route path="/guia-alimentacion" element={<FoodGuide />} />
      <Route path="/mis-descargas" element={<MyLibrary />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/nutricion" element={<ProtectedRoute><Nutrition /></ProtectedRoute>} />
      <Route path="/entrenamiento" element={<ProtectedRoute><Training /></ProtectedRoute>} />
      <Route path="/seguimiento" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />
      <Route path="/whatsapp" element={<ProtectedRoute adminOnly><Whatsapp /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <AccessibilityWidget />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0D0D0D",
                border: "1px solid #39FF14",
                color: "#FFFFFF",
                borderRadius: 0,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
